export enum StorageKeys {
  IS_SHELL = 'isShell',
  TEMP_LANG = 'tempLang',
  COUNTRY = 'country',
  ORIGIN_URL = 'originUrl',
  COUNTRY_RULES = 'countryRules',
  LOGIN_SELECTED_COUNTRY = 'loginSelectedCountry',
  SOURCE = 'source',
  CAT = 'cat',
  AUTH_TOKEN = 'authToken',
  USER_PROFILE = 'userProfile',
  USER_VEHICLES = 'userVehicles',
  URL_INFOS = 'urlInfos',
  VIN_ACTIVE_DASHBOARD = 'vehicle-carousel-vin', // TODO: mudar esse nome depois
  FEATURE_TOGGLE = 'feature-toggle',
  SOURCE_ADD_VEHICLE = 'source-add-vehicle',

  //history
  REVISION_HISTORY = 'revision-history',
  SCHEDULE_HISTORY = 'schedule-history',
  REVISIONS_PARTS = 'revisions-parts',

  OPEN_SCHEDULES = 'open-schedules',
  STATUS_SCHEDULES = 'status-schedules',
  SCHEDULE_ID = 'scheduleId',
  SCHEDULE_DETAILS = 'scheduleDetails',
  DEALER_ID = 'dealerId',
  DEALER_SELECTED = '@Ford-dealerSelected',

  CATEGORIES_BY_DEALER = '@Ford-categoriesByDealer',

  VIN = 'vin',
  VEHICLE_DETAILS = 'vehicleDetails',

  COUNTRY_NOT_FOUND = 'COUNTRY_NOT_FOUND',
  LANGUAGE_NOT_FOUND = 'LANGUAGE_NOT_FOUND',

  WAITING_OPTION = 'waitingOption'
}
